import { Suspense, useCallback, useRef } from "react";
import "@/common/styles/variables.css";
import "./App.scss";
import "@/common/services/localMetrics/handlers";
import "@/common/services/amplitude/handlers";
import "@/common/services/ga/handlers";
import "@/common/services/microsoftClarity/handlers";
import { BrowserRouter } from "react-router-dom";
import { ApplicationFooter } from "components/footer/ApplicationFooter";
import { ApplicationHeader } from "components/header/ApplicationHeader";
import { AppHooks } from "components/app/AppHooks";
import { AppContent } from "components/app/AppContent";
import { setAppHeight } from "./utils/appHeight";
import { PopupDispatcher } from "components/popup-dispatcher/PopupDispatcher";
import { ResponseMessage } from "components/UI/ResponseMessage";
import { checkIncognito } from "@/common/utils/detectIncognito";
import { Partytown } from "@builder.io/partytown/react";
import { useScrollElement } from "./hooks/useScrollElement";

window.addEventListener("resize", setAppHeight);
setAppHeight();
checkIncognito();

export const App = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  useScrollElement({ scrollRef });

  const resolveBeaconRequestParameters = useCallback((url: URL) => {
    return url.hostname.includes("analytics.google") || url.hostname.includes("google-analytics")
      ? { keepalive: false }
      : null;
  }, []);

  return (
    <div className="App nav" ref={scrollRef}>
      <BrowserRouter>

        <ApplicationHeader />

        <AppContent />

        <Suspense><ApplicationFooter /></Suspense>

        <PopupDispatcher />
        <AppHooks />
        <Partytown
          debug={import.meta.env.REACT_APP_PARTY_TOWN_DEBUG === "1"}
          forward={["dataLayer.push"]}
          resolveSendBeaconRequestParameters={resolveBeaconRequestParameters}
        />
      </BrowserRouter>

      <Suspense><ResponseMessage /></Suspense>
    </div>
  );
};
